import Api from '@/api/apis'
import { mapGetters } from 'vuex'
import apiFunc from '@/api/index'

export default {
  computed: {
    ...mapGetters({
      getRangeTime: 'getRangeTime'
    })
  },
  data () {
    return {
      loadingCnt: 0,
      notNeedAuthList: [
        'getSubscItems'
      ]
    }
  },
  methods: {
    request (method, params, cbsuccess, cbfail, isSilent = false) {
      // if (!this.isAuth && !this.notNeedAuthList.includes(method)) {
      //   return
      // }
      if (!isSilent) {
        this.loadingCnt++
      }
      params['range_start_time'] = this.getRangeTime[0]
      params['range_end_time'] = this.getRangeTime[1]
      Api.apis[ method ](params).then(data => {
        if (!isSilent) {
          this.loadingCnt--
        }
        if (typeof data !== 'undefined') {
          if (cbsuccess) {
            cbsuccess(data)
          }
        } else {
          if (!isSilent) {
            this.requestFail(new Error('接口数据出错'))
          }
          if (cbfail) {
            cbfail(new Error('接口数据出错'))
          }
        }
      }, err => {
        console.error(err)
        if (!isSilent) {
          this.loadingCnt--
          this.requestFail(err)
        }
        if (cbfail) {
          cbfail(err)
        }
      }).catch(err => {
        console.error(err)
        if (!isSilent) {
          this.requestFail(err)
        }
        if (cbfail) {
          cbfail(err)
        }
      })
    },
    requestPost (url, params, cbsuccess, cbfail, isSilent = false) {
      if (!isSilent) {
        this.loadingCnt++
      }
      params['range_start_time'] = this.getRangeTime[0]
      params['range_end_time'] = this.getRangeTime[1]
      apiFunc.actionCreatorPost('/api/schedule/' + url, params).then(data => {
        if (!isSilent) {
          this.loadingCnt--
        }
        if (typeof data !== 'undefined') {
          if (cbsuccess) {
            cbsuccess(data)
          }
        } else {
          if (!isSilent) {
            this.requestFail(new Error('接口数据出错'))
          }
          if (cbfail) {
            cbfail(new Error('接口数据出错'))
          }
        }
      }, err => {
        console.error(err)
        if (!isSilent) {
          this.loadingCnt--
          this.requestFail(err)
        }
        if (cbfail) {
          cbfail(err)
        }
      }).catch(err => {
        console.error(err)
        if (!isSilent) {
          this.requestFail(err)
        }
        if (cbfail) {
          cbfail(err)
        }
      })
    },
    requestFail (err) {
      console.log(err.message)
      console.log(err.code)
      if (err.code && err.code === 2001) {
        this.$message.warning(err.message)
      } else {
        this.$message.error(err.message)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/request.js